"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timePlot = exports.popPyramidPlot = exports.plotByProperty = exports.plotByPropertyByDate = exports.arrayOfYearAndProperty = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactVis = require("react-vis");

var _d3Format = require("d3-format");

var _geojsonutils = require("../../geojsonutils");

var _JSUtils = require("../../JSUtils");

var _Constants = require("../../Constants");

var _utils = require("../../utils");

var _d3Scale = require("d3-scale");

var _GenericPlotly = _interopRequireDefault(require("./GenericPlotly"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var W = _Constants.PLOT_W,
    COLOR_F = 'rgb(18, 147, 154)',
    COLOR_M = 'rgb(239, 93, 40)';

var plotByPropertyByDate = function plotByPropertyByDate(data, property, dark) {
  if (!data || !(0, _JSUtils.isArray)(data) || !data.length || !property) return null;
  var plot_data_multi = arrayOfYearAndProperty(data, property);
  if (!plot_data_multi) return null;
  return _react["default"].createElement(_GenericPlotly["default"], {
    dark: dark,
    yaxis: {
      showgrid: false
    },
    xaxis: {
      showgrid: false
    },
    data: plot_data_multi.map(function (r, i) {
      return {
        mode: 'lines',
        showlegend: false,
        x: r.map(function (e) {
          return e.x;
        }).sort(function (a, b) {
          return new Date(a) - new Date(b);
        }),
        y: r.map(function (e) {
          return e.y;
        }),
        name: ["Male", "Female", "Total"][i],
        marker: {
          color: (0, _d3Scale.scaleSequential)(_Constants.TURQUOISE_RANGE)(i / plot_data_multi.length)
        }
      };
    }),
    title: "Sex of Casualty"
  });
};

exports.plotByPropertyByDate = plotByPropertyByDate;

var plotByProperty = function plotByProperty(data, property, dark, type, noLimit) {
  if (!data || !(0, _JSUtils.isArray)(data) || !data.length) return null;
  var limit = 10;
  var isOverLimit = !noLimit && data.length > limit;
  var data_by_prop = data[0].properties.hasOwnProperty(property) && (0, _utils.xyObjectByProperty)(isOverLimit ? data.slice(0, limit) : data, property);
  if (!data_by_prop) return null;
  return _react["default"].createElement(_react["default"].Fragment, null, isOverLimit && _react["default"].createElement("h4", null, "Plotting first ", limit, " values:"), _react["default"].createElement(_GenericPlotly["default"], {
    dark: dark,
    yaxis: {
      showgrid: false
    },
    xaxis: {
      showgrid: false
    },
    data: [{
      x: data_by_prop.map(function (e) {
        return e.x;
      }),
      y: data_by_prop.map(function (e) {
        return e.y;
      }),
      marker: {
        color: _Constants.TURQUOISE_RANGE[0]
      },
      type: type || 'lines'
    }],
    title: (0, _utils.humanize)(property)
  }));
};

exports.plotByProperty = plotByProperty;

var popPyramidPlot = function popPyramidPlot(options) {
  if (!options || !options.data || !options.data[0] || !options.data[0].properties.date || !options.data[0].properties.sex_of_casualty) return;
  var mf = (0, _geojsonutils.propertyCountByProperty)(options.data, "sex_of_casualty", "date");
  var mf_array_male = [];
  var mf_array_female = [];
  if (Object.keys(mf).length === 1) return;
  mf && Object.keys(mf).forEach(function (y, i) {
    mf_array_male.push({
      x: 0,
      x0: +mf[y].Male,
      y: i === 0 ? 0 : i,
      y0: i + 1,
      color: "#428BCA"
    });
  });
  mf && Object.keys(mf).forEach(function (y, i) {
    mf_array_female.push({
      x: 0,
      x0: -1 * +mf[y].Female,
      y: i === 0 ? 0 : i,
      y0: i + 1
    });
  });
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_reactVis.XYPlot, {
    margin: {
      left: options.margin || 60
    },
    height: options.plotStyle && options.plotStyle.height || W,
    width: options.plotStyle && options.plotStyle.width || W
  }, _react["default"].createElement(_reactVis.HorizontalRectSeries, {
    color: COLOR_F,
    stroke: "black",
    data: mf_array_female
  }), _react["default"].createElement(_reactVis.HorizontalRectSeries, {
    color: COLOR_M,
    stroke: "black",
    data: mf_array_male
  }), _react["default"].createElement(_reactVis.YAxis, {
    tickSize: 0,
    tickFormat: function tickFormat(v) {
      return v === 0 ? 2009 : v - 2 + 2009;
    },
    style: {
      line: {
        strokeWidth: 0
      },
      text: {
        fill: options.dark ? '#fff' : '#000',
        fontWeight: 400
      }
    }
  }), _react["default"].createElement(_reactVis.XAxis, {
    tickSize: 0,
    tickFormat: function tickFormat(v) {
      return (0, _d3Format.format)(".2s")(v < 0 ? -1 * v : v);
    },
    style: {
      line: {
        strokeWidth: 0
      },
      text: {
        fill: options.dark ? '#fff' : '#000',
        fontWeight: 400
      }
    }
  })), _react["default"].createElement(_reactVis.DiscreteColorLegend, {
    orientation: "horizontal",
    width: W,
    items: [{
      title: "Male",
      color: COLOR_M
    }, {
      title: "Female",
      color: COLOR_F
    }]
  }));
};

exports.popPyramidPlot = popPyramidPlot;

var arrayOfYearAndProperty = function arrayOfYearAndProperty(data, column) {
  var notEmpty = (0, _JSUtils.isArray)(data) && data.length > 0 && column;
  var plot_data_multi = [[], [], []];

  if (notEmpty) {
    var n = data.length === 1 ? 0 : Math.floor(Math.random() * (data.length - 1) + 1);
    var timeCols = Object.keys(data[n].properties).filter(function (each) {
      return (0, _utils.isStringDate)(data[n].properties[each]);
    });

    if (timeCols.length > 0) {
      var mf = (0, _geojsonutils.propertyCountByProperty)(data, column, timeCols[0]);
      mf && Object.keys(mf).length > 1 && Object.keys(mf).forEach(function (y) {
        if (y && mf[y].Male && mf[y].Female) {
          plot_data_multi[0].push({
            x: y,
            y: mf[y].Male
          });
          plot_data_multi[1].push({
            x: y,
            y: mf[y].Female
          });
          plot_data_multi[2].push({
            x: y,
            y: mf[y].Male + mf[y].Female
          });
        }
      });
    }
  }

  if (!plot_data_multi[0].length) return null;
  return plot_data_multi;
};

exports.arrayOfYearAndProperty = arrayOfYearAndProperty;

var timePlot = function timePlot() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var data = props.data,
      property = props.property,
      dark = props.dark,
      title = props.title,
      height = props.height,
      width = props.width,
      onClickCallback = props.onClickCallback;
  if (!(0, _JSUtils.isString)(property) || !data || !data.length) return null;
  var dateColumn = (0, _utils.getFirstDateColumnName)(data[0].properties);
  if (!dateColumn) return null;
  var x = (0, _geojsonutils.getPropertyValues)({
    features: data
  }, dateColumn).map(function (e) {
    return new Date(e);
  });
  var y = (0, _geojsonutils.getPropertyValues)({
    features: data
  }, property);
  return _react["default"].createElement(_GenericPlotly["default"], {
    dark: dark,
    height: height,
    width: width,
    title: title || dateColumn + " v " + property,
    yaxis: {
      showgrid: false
    },
    xaxis: {
      showgrid: false
    },
    data: [{
      x: x,
      y: y,
      mode: 'graph'
    }],
    onClickCallback: onClickCallback
  });
};

exports.timePlot = timePlot;